var React = require('react');

function Play (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8 5v14l11-7z","key":0}),React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":1})]);
}

Play.defaultProps = {"height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Play;

Play.default = Play;
